import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../modal/PropdocsModal';
import { TitleFormattedMessage } from '../titleFormattedMessage';
import '../templates/ActiveInactiveDropdown.scss';

interface SignOutConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SignOutConfirmationModal = ({ show, onClose, onConfirm }: SignOutConfirmationModalProps) => {
  return (
    <PropdocsModal
      show={show}
      setShow={onClose}
      title={<FormattedMessage id="title.sign-out" defaultMessage="Sign Out" />}
      size="md"
    >
      <div className="confirmation-modal-content" data-testid="sign-out-confirmation-modal">
        <div className="confirmation-modal-body">
          <FormattedMessage
            id="phrase.confirm-sign-out"
            defaultMessage="Are you sure you want to sign out of Propdocs?"
          />
        </div>
        <div className="confirmation-modal-actions">
          <Button variant="link" className="text-secondary" onClick={onClose} data-testid="sign-out-cancel-button">
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={onConfirm} data-testid="sign-out-confirm-button">
            <TitleFormattedMessage id="cta.sign-out" defaultMessage="Sign Out" />
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default SignOutConfirmationModal;
